import { render, staticRenderFns } from "./AdmissionOlderList.vue?vue&type=template&id=8bd7fc30&scoped=true"
import script from "./AdmissionOlderList.vue?vue&type=script&lang=js"
export * from "./AdmissionOlderList.vue?vue&type=script&lang=js"
import style0 from "./AdmissionOlderList.vue?vue&type=style&index=0&id=8bd7fc30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd7fc30",
  null
  
)

export default component.exports